var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEars1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 85,
    viewBox: "0 0 67 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67 42.5C67 65.9721 52.0015 85 33.5 85C14.9985 85 0 65.9721 0 42.5C0 19.0279 14.9985 0 33.5 0C52.0015 0 67 19.0279 67 42.5Z",
    fill: "#E6AB87"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 52V19H31.0603V33.3068C31.7696 32.1757 32.5382 31.1307 33.3561 30.1845C37.7196 25.1358 44.0224 22.4672 50 25.9322L47.5425 30.5478C44.4116 28.7328 40.5939 29.6942 37.1139 33.7205C33.6565 37.7208 31.0603 44.3293 31.0603 52H26Z",
    fill: "#402D27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEars1);
export default __webpack_public_path__ + "static/media/ears-1.ca729f07581f85191160d62d769f02db.svg";
export { ForwardRef as ReactComponent };